import React from 'react';
import { Modal, Button, Typography } from 'antd';

const { Text } = Typography;

const TemplateBidsModal = ({
  visible,
  onClose,
  selectedLot,
  getTemplateBids,
  handleTemplateBidSelect,
  formatCurrency
}) => {
  if (!selectedLot) return null;

  const templateBids = getTemplateBids();

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
            boxShadow: '0 2px 8px rgba(24, 144, 255, 0.3)'
          }}>
            📋
          </div>
          <div>
            <div style={{ fontSize: '18px', fontWeight: 700, color: '#262626', lineHeight: '1.2' }}>
              Template Bids
            </div>
            <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '2px' }}>
              Select a bid amount to use
            </div>
          </div>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      style={{ top: 50 }}
      bodyStyle={{ padding: '24px' }}
    >
      {/* Current Price & Increment */}
      <div style={{ 
        marginBottom: 20, 
        padding: '16px 20px', 
        background: 'linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%)', 
        borderRadius: '10px',
        border: '2px solid #91d5ff',
        boxShadow: '0 2px 8px rgba(24, 144, 255, 0.15)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginBottom: 6, color: '#595959' }}>
              Current Price
            </Text>
            <Text strong style={{ fontSize: '24px', color: '#1890ff', fontWeight: 700, lineHeight: '1.2' }}>
              {formatCurrency(selectedLot.current_price || selectedLot.starting_price)}
            </Text>
          </div>
          <div style={{ textAlign: 'right' }}>
            <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginBottom: 6, color: '#595959' }}>
              Increment
            </Text>
            <Text strong style={{ fontSize: '16px', color: '#52c41a', fontWeight: 600 }}>
              {formatCurrency(parseInt(selectedLot.default_increment) || parseInt(selectedLot.increment) || 5)}
            </Text>
          </div>
        </div>
      </div>

      {/* Template Bids Grid */}
      {templateBids.length > 0 ? (
        <>
          <div style={{ maxHeight: '500px', overflowY: 'auto', paddingRight: '4px' }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
              gap: '12px'
            }}>
              {templateBids.map((template, idx) => {
                const isPopular = template.multiplier <= 5;
                const isFractional = template.multiplier < 1;

                return (
                  <Button
                    key={idx}
                    type={isPopular ? "primary" : "default"}
                    onClick={() => handleTemplateBidSelect(template.amount)}
                    style={{
                      height: 'auto',
                      minHeight: '100px',
                      padding: '14px 12px',
                      borderRadius: '10px',
                      border: isFractional ? '2px solid #ffd591' : (isPopular ? 'none' : '2px solid #e8e8e8'),
                      background: isFractional 
                        ? 'linear-gradient(135deg, #fff7e6 0%, #ffecc7 100%)'
                        : isPopular 
                          ? 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)' 
                          : 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)',
                      boxShadow: isFractional
                        ? '0 2px 6px rgba(250, 173, 20, 0.2)'
                        : isPopular 
                          ? '0 4px 12px rgba(24, 144, 255, 0.3)' 
                          : '0 2px 6px rgba(0, 0, 0, 0.08)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  >
                    <div style={{ 
                      fontSize: '16px', 
                      fontWeight: 700, 
                      color: isFractional ? '#262626' : (isPopular ? '#fff' : '#262626'),
                      marginBottom: '4px',
                      textAlign: 'center',
                      lineHeight: '1.2'
                    }}>
                      {template.label.charAt(0).toUpperCase() + template.label.slice(1)}
                    </div>
                    <div style={{ 
                      fontSize: '11px', 
                      color: isFractional ? '#8c8c8c' : (isPopular ? 'rgba(255, 255, 255, 0.9)' : '#8c8c8c'),
                      marginBottom: '4px',
                      textAlign: 'center',
                      lineHeight: '1.2'
                    }}>
                      +{formatCurrency(template.incrementAmount)}
                    </div>
                    <div style={{ 
                      fontSize: '16px', 
                      color: isFractional ? '#1890ff' : (isPopular ? '#fff' : '#1890ff'),
                      fontWeight: 700,
                      textAlign: 'center',
                      lineHeight: '1.2'
                    }}>
                      {formatCurrency(template.amount)}
                    </div>
                  </Button>
                );
              })}
            </div>
          </div>

          {/* Info Footer */}
          <div style={{
            marginTop: '16px',
            padding: '12px',
            background: '#f6ffed',
            borderRadius: '6px',
            border: '1px solid #b7eb8f'
          }}>
            <Text style={{ fontSize: '12px', color: '#52c41a', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>💡</span>
              <span>Click any template to auto-fill the custom bid amount</span>
            </Text>
          </div>
        </>
      ) : (
        <div style={{ 
          textAlign: 'center', 
          padding: '40px 20px',
          color: '#8c8c8c',
          fontSize: '14px',
          background: '#fafafa',
          borderRadius: '8px',
          border: '1px dashed #d9d9d9'
        }}>
          No template bids available
        </div>
      )}
    </Modal>
  );
};

export default TemplateBidsModal;
